import requestManager from "@/components/platformApi/requestManager";
import appConfig from "@/appConfig";
import consoleApi from "@comp/platformApi/consoleApi";

export default {

    /**
     * add a accessing record
     * @param   {Object}    data
     * @param   {Object}    data.pageKey
     * @param   {Object}    data.pageName
     * @param   {Object}    data.pageRoute
     */
    add(data, callback = null) {

        data.client = 'WEB';
        data.clientVersion = appConfig.version;
        data.networkEnv = window.app.networkType;

        requestManager.request({
            url : 'portal/client/log',
            method : 'post',
            data : data
        }, (error, result) => {
            if (error)
            {
                consoleApi.error(error);
                return;
            }

            if (result.errorCode)
            {
                consoleApi.error(result.msg);
                return;
            }

            callback ? callback(result.data) : null;
        });
    },

    /**
     * update a accessing record
     * @param   {String}    id
     */
    update(id, callback = null) {

        requestManager.request({
            url : 'portal/client/log',
            method : 'put',
            data : {
                id : id
            }
        }, (error, result) => {
            callback ? callback(error, result) : null;
        });
    },



}
